// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/components/bisystem/canvas/main/cells/cell/calendar/calendar.small/calendar.small.header/calendar.small.header.scss
// module id = 4914
// module chunks = 50